var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 14a1.468 1.468 0 0 0 1.055-.445l9.645-9.84a1.001 1.001 0 0 0 0-1.43 1 1 0 0 0-1.415 0L5 11.775l-3.3-3.47a1 1 0 0 0-1.41 0 1 1 0 0 0 0 1.43l3.65 3.825A1.5 1.5 0 0 0 5 14Z"
  })));
};
export default SvgCheckmark;